import { MobileDatagrid } from "./datagrid-mobile";
import { DefaultDatagrid } from "./datagrid-simple";
import { DatagridCombo } from "./datagrid-combo";
import { Container } from "./datagrid-simple/styles";
export const DatagridResponsive = {
  Container: Container,
  Default: DefaultDatagrid,
  Mobile: MobileDatagrid,
  Combo: DatagridCombo,
};
